module.exports = "https://cdn.thelire.com/ins/resource/lh_store_vip_ads.46272e7abfe685968bdb841357095163.png";